<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId != 1 || loginUserRoleId != 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <!-- Empolyee Number -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Emp Number :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" maxlength="190" class="form-control" v-model="employeeNumber" id="empolyee_name" placeholder="Enter Employee Number" name="employeeNumber">
                                <div class="help is-danger">{{employeeNumberError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Empolyee Name -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">EMPLOYEE'S FULL NAME :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" maxlength="190" class="form-control" v-model="employeeName" id="empolyee_name" placeholder="Enter Employee Name" name="employeeName">
                                <div class="help is-danger">{{employeeNameError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>

                        <!-- Date -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Date :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <date-picker placeholder="MM/DD/YYYY" id="date_of_request" name="date" v-model="date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                <div class="help is-danger">{{dateError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <!-- Location -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="location" name="location"
                                    label="name" placeholder="Select Location"
                                    :options="location_arr" :clearable=false>
                                </v-select>
                                <div class="help is-danger">{{location_error}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>

                        <!-- Empolyee Email -->
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">EMP. EMAIL ADDRESS :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" maxlength="190" class="form-control" v-model="employeeEmail" id="employeeEmail" placeholder="Enter Employee Email" name="employeeEmail">
                                <div class="help is-danger">{{employeeEmailError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        
                        <div class="col-4 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">&nbsp;</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                &nbsp;
                            </div>
                        </div>
                        
                        <div class="col-12 forms-block">
                            <div class="col-12 paddingleft0">
                                <div class="form-label block-title-tech-time">Attendance Clock Time Corrections</div>
                            </div>
                        </div>
                        <template v-for="(attendance, index) in attendanceClockTimeArr">
                            <div :key="'date ' + index" class="col-2 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Date :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker placeholder="MM/DD/YYYY" id="date" name="date" v-model="attendance.date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                </div>
                            </div>
                            <div :key="'Reson ' + index" class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Reason for Edit :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" maxlength="190" class="form-control" v-model="attendance.reason" id="reason" name="reason">
                                </div>
                            </div>
                            <div :key="'Time In ' + index" class="col-2 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Time In :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" maxlength="190" class="form-control" v-model="attendance.timeIn" placeholder="HH:MM" id="timeIn" name="timeIn">
                                </div>
                            </div>
                            <div :key="'Time Out ' + index" class="col-2 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Time Out :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" maxlength="190" class="form-control" v-model="attendance.timeOut" placeholder="HH:MM" id="timeOut" name="timeOut">
                                </div>
                            </div>
                        </template>
                        <!-- <template v-if="plusCount != 0">
                            <div class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
                                <button type="button" v-on:click="addNewDocument" class="btn btn-success">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template> -->
                        <div class="col-12 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label block-title-tech-time">Shop Time Corrections</div>
                            </div>
                        </div>
                        <template v-for="(shopObj, index) in shopTimeObjects">
                            <div :key="'Shop Date ' + index" class="col-3 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Date :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <date-picker placeholder="MM/DD/YYYY" id="date" name="date" v-model="shopObj.date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                </div>
                            </div>
                            <div :key="'Shop Customer Name ' + index" class="col-3 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Customer Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" maxlength="190" class="form-control" v-model="shopObj.customerName" placeholder="" id="customerName" name="customerName">
                                </div>
                            </div>
                            <div :key="'Shop RO Number ' + index" class="col-3 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">RO Number :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" maxlength="190" class="form-control" v-model="shopObj.roNumber" placeholder="" id="roNumber" name="roNumber">
                                </div>
                            </div>
                            <div :key="'Shop Reason ' + index" class="col-3 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Reason :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" maxlength="190" class="form-control" v-model="shopObj.reason" placeholder="" id="reason" name="reason">
                                </div>
                            </div>
                            <div :key="'Shop Job ' + index" class="col-3 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Job :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" maxlength="190" class="form-control" v-model="shopObj.job" placeholder="" id="job" name="job">
                                </div>
                            </div>
                            <div :key="'Shop Time In ' + index" class="col-3 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Time In :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" maxlength="190" class="form-control" v-model="shopObj.timeIn" placeholder="HH:MM" id="timeIn" name="timeIn">
                                </div>
                            </div>
                            <div :key="'Shop Time Out ' + index" class="col-3 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Time Out :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" maxlength="190" class="form-control" v-model="shopObj.timeOut" placeholder="HH:MM" id="timeOut" name="timeOut">
                                </div>
                            </div>
                            <template v-if="shopTimeObjects.length == index + 1 && plusCount != 0">
                                <div :key="'Shop Plus Button ' + index" class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
                                    <button type="button" v-on:click="addNewDocument" class="btn btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                            <div :key="'Shop clearfix ' + index" class="col-0 forms-block">
                                <!-- <div class="col-3 paddingleft0">
                                    <div class="form-label">&nbsp;</div>
                                </div> -->
                                <!-- <div class="col-9 paddingleft0">
                                    &nbsp;
                                </div> -->
                            </div>
                        </template>

                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button v-if="loginUserRoleId != 1 || loginUserRoleId != 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addUser('save')"><span id="createAttachment">Save</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateTechTime',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Tech Time Edit Form',
                edit_id: 0,
                employeeNumber: "",
                employeeNumberError: "",
                employeeName: "",
                employeeNameError: "",
                date: "",
                dateError: "",
                options: {
                    format: 'MM/DD/YYYY',
                },
                location: "",
                location_arr: [],
                location_error: "",
                employeeEmail: "",
                employeeEmailError: "",
                attendanceClockTimeArr: [
                    {
                        date: "",
                        reason: "",
                        timeIn: "",
                        timeOut: "",
                    },
                    {
                        date: "",
                        reason: "",
                        timeIn: "",
                        timeOut: "",
                    },
                    {
                        date: "",
                        reason: "",
                        timeIn: "",
                        timeOut: "",
                    },
                    {
                        date: "",
                        reason: "",
                        timeIn: "",
                        timeOut: "",
                    },
                ],
                managerEmail: "",
                loginUserRoleId: 1,
                shopTimeObjects: [
                    {
                        date: '',
                        customerName: '',
                        roNumber: '',
                        reason: '',
                        job: '',
                        timeIn: '',
                        timeOut: '',
                    },
                    {
                        date: '',
                        customerName: '',
                        roNumber: '',
                        reason: '',
                        job: '',
                        timeIn: '',
                        timeOut: '',
                    },
                    {
                        date: '',
                        customerName: '',
                        roNumber: '',
                        reason: '',
                        job: '',
                        timeIn: '',
                        timeOut: '',
                    },
                    {
                        date: '',
                        customerName: '',
                        roNumber: '',
                        reason: '',
                        job: '',
                        timeIn: '',
                        timeOut: '',
                    },
                ],
                tempObject: {
                    date: '',
                        customerName: '',
                        roNumber: '',
                        reason: '',
                        job: '',
                        timeIn: '',
                        timeOut: '',
                },
                plusCount: 16,
            }
        },
        watch: {
            pay_type: function(pay_type) {
                self.isWarrantySelect = false;
                if(pay_type.value == 'Warranty') {
                    self.isWarrantySelect = true;
                }
            },
            location: function(location) {
                self.managerEmail = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                        }
                    }
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("TechTimeForm");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }
            self.loadLocation();
        },
        methods: {
            buttonBack() {
                self.$router.push('/techtime/list');
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "velocity-vehicle-group",
                        department_id: 3
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/getdepartmentlocationswohtml", config)
                        .then(function (response) {
                            self.location_arr = response.data.locations;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            addNewDocument: function () {
                self.plusCount = self.plusCount - 1;
                self.shopTimeObjects.push(Vue.util.extend({}, self.tempObject))
                console.log(self.shopTimeObjects.length);
            },
            checkForm: function () {
                var checked = true;
                // console.log(JSON.stringify(self.shopTimeObjects));return false;
                self.employeeNumberError = "";
                self.employeeNameError = "";
                self.dateError = "";
                self.employeeEmailError = "";
                self.location_error = "";

                if (!self.employeeNumber) {
                    self.employeeNumberError = "Please enter employee number";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeName) {
                    self.employeeNameError = "Please enter employee name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date) {
                    self.dateError = "Select Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.location == null || !self.location.id) {
                    self.location_error = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employeeEmail) {
                    self.employeeEmailError = "employee Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.employeeEmail && !self.validEmail(self.employeeEmail)) {
                    self.employeeEmailError = "Please Enter Valid employee Email";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addUser(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        var fields = {
                            manager_email: self.managerEmail,
                            empolyee_number: self.employeeNumber,
                            date: self.date,
                            empolyee_name: self.employeeName,
                            location: self.location.name,
                            employee_email: self.employeeEmail,
                            attendanceClockTimeArr: self.attendanceClockTimeArr,
                            shopTimeObjects: self.shopTimeObjects,
                        };
                        self.showLoader();
                        HTTP.post("/techtime/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                        self.buttonBack();
                                    } else {
                                        self.employeeNumber = '';
                                        self.date = '';
                                        self.employeeName = '';
                                        self.location = '';
                                        self.employeeEmail = '';
                                        self.managerEmail = '';
                                        self.attendanceClockTimeArr = [
                                            {
                                                date: "",
                                                reason: "",
                                                timeIn: "",
                                                timeOut: "",
                                            },
                                            {
                                                date: "",
                                                reason: "",
                                                timeIn: "",
                                                timeOut: "",
                                            },
                                            {
                                                date: "",
                                                reason: "",
                                                timeIn: "",
                                                timeOut: "",
                                            },
                                            {
                                                date: "",
                                                reason: "",
                                                timeIn: "",
                                                timeOut: "",
                                            },
                                        ];
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
</script>
<style scoped>
    .block-title-tech-time {
        float: left;
        width: 100%;
        margin: 0 0 15px 0;
        padding: 0;
        font-weight: normal;
        font-size: 28px;
        color: #0f467c;
        font-family: 'SanFranciscoDisplay-Bold';
    }
</style>


// WEBPACK FOOTER //
// src/components/Forms/TechTimeMaster/AddUpdateTechTime.vue